'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartGroupCard } from '@/app/(main)/_components/cart/cart-group-card.component';
import { CartItemDetails } from '@/app/(main)/_components/cart/cart-item/cart-item-details.component';
import { CartItemHeader } from '@/app/(main)/_components/cart/cart-item/cart-item-header.component';
import { CartItem } from '@/types/cart.types';

interface CartProfessionalGroupProps {
  items: CartItem[];
  onEditSchedule?: (item: CartItem) => void;
  onEditPatient?: (item: CartItem) => void;
  onRemove?: (item: CartItem) => void;
}

export function CartProfessionalGroup({
  items,
  onEditSchedule,
  onEditPatient,
  onRemove,
}: CartProfessionalGroupProps) {
  const [firstItem] = items;

  return (
    <CartGroupCard className="gap-4" dataTestId={DataTestIdEnum.CART_PROFESSIONAL_GROUP}>
      <CartItemHeader
        item={firstItem}
        dataTestId={DataTestIdEnum.CART_PROFESSIONAL_GROUP_HEADER}
      />

      {items.map((item) => (
        <div
          key={item.id}
          className="flex w-full flex-col gap-2 rounded-lg border border-gray-300 bg-white p-3"
          data-testid={DataTestIdEnum.CART_PROFESSIONAL_GROUP_ITEM}
        >
          <CartItemDetails
            item={item}
            onEditSchedule={onEditSchedule && (() => onEditSchedule(item))}
            onEditPatient={onEditPatient && (() => onEditPatient(item))}
            onRemove={onRemove && (() => onRemove(item))}
          />
        </div>
      ))}
    </CartGroupCard>
  );
}
